import StepperNav from "../../serverDetails/steps/stepperNav";
import { useEffect, useState } from "react";
import { useGetServer } from "../../../../api/userInfo";
import { useTranslation } from 'react-i18next'

const SelectDeviceServer = ({step, setStep, setType, type, onClose}) => {
    const plantId = localStorage.getItem('plantId')
    const { t } = useTranslation("settings");
    // const [selectedType, setSelectedType] = useState(type); //['IoT Database', 'MQTT', 'huawei-cloud'
    const [isValid, setIsValid] = useState(type);
    const { serverList, isErrorServerList, isLoadingServerList} = useGetServer(plantId)
    const [nextLabel, setNextLabel] = useState(`${t('device_management.device_setup.config')}`)

    useEffect(() => {
        if (type) {
            setIsValid(true);
        }
    }, [type])
    
    const onOptionChange = (e) => {
        setNextLabel(`${t('device_management.device_setup.config')}`)
        setType(e.target.value)
        setIsValid(true);
    }
    return ( 
        <div className="w-full font-normal">

            {step==1 &&

                <>
                <span className="block text-sm font-semibold text-gray-700">1. {t('device_management.device_setup.select_server')}</span>
                
                <div className="flex flex-col gap-4 mt-2 ml-2 text-sm ">
                <label className="inline-flex items-center gap-2 cursor-pointer">
                            <input type="radio" name="server" value={"vehicle"} 
                            className="w-4 h-4 cursor-pointer accent-emerald-700 hover:accent-emerald-700" 
                            // checked={server.type}
                            defaultChecked={type == "vehicle"}
                            onChange={onOptionChange}
                            />
                            {/* Vehicle */}
                            {t('device_management.device_setup.vehicle')}
                        </label>
                        <label className="inline-flex items-center gap-2 cursor-pointer">
                            <input type="radio" name="server" value={"huawei-cloud"} 
                            className="w-4 h-4 cursor-pointer accent-emerald-700 hover:accent-emerald-700" 
                            // checked={server.type}
                            defaultChecked={type == "huawei-cloud"}
                            onChange={onOptionChange}
                            />
                            {/* Huawei Cloud */}
                            {t('device_management.device_setup.Huawei')}
                        </label>
                        
                        <label className="inline-flex items-center gap-2 cursor-pointer">
                            <input type="radio" name="server" value={"influxdb"} 
                            className="w-4 h-4 cursor-pointer accent-emerald-700 hover:accent-emerald-700" 
                            defaultChecked={type == "influxdb"}
                            onChange={onOptionChange}
                            />
                            {/* Other */}
                            {t('device_management.device_setup.other')}
                        </label>
                </div>

                

                 <StepperNav step={step} setStep={setStep} isValid={isValid}  prev={`${t('device_management.device_setup.cancel')} `} next={nextLabel} onClose={onClose} />
                </>
            }

            </div>
     );
}
 
export default SelectDeviceServer;